import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "video"]

  connect() {
    // Debug connection
    console.log("Modal controller connected");
  }

  open() {
    console.log("Opening modal");
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    
    // If we have a video element, play it
    if (this.hasVideoTarget) {
      console.log("Video element found");
      this.videoTarget.play().catch(e => console.log("Video play error:", e));
    }
  }

  close() {
    console.log("Closing modal");
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
    
    // If we have a video element, pause it
    if (this.hasVideoTarget) {
      this.videoTarget.pause();
      this.videoTarget.currentTime = 0;
    }
  }
  
  // This will close the modal when the escape key is pressed
  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
  
  // This will close the modal if the backdrop is clicked
  closeWithBackdrop(event) {
    // Only close if the click was directly on the backdrop
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
} 